export default function Maintenance() {
    return (
        <div className="">
            <h1>System Maintenance</h1><br /> 
            <h2>The iToplight Cloud is currently undergoing maintenance. It will be back online shortly.</h2>
        </div>
    );
}
